// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `details {
    --lastseen-border: 0.125rem solid #00C49A;
    --lastseen-border-radius: 0.75rem;
    --lastseen-padding: 0.25rem 0.75rem;
}

details {
    --default-icon-color: #fff;
    background: var(--ocean-gradient);
    color: #fff;
    border: var(--lastseen-border);
    border-radius: 0.75rem;
    padding: 0.25rem 0.75rem 0.25rem 0.5rem;
    margin: 0.75rem -0.25rem 0.25rem -0.125rem;
    cursor: pointer;
    width: 100%;
    box-sizing: border-box;
    contain: content;
}

details>summary {
    list-style: none;
    display: grid;
    grid-template-columns: auto 1fr auto;
    align-items: center;
    gap: 0.5rem;
    min-height: 1.75rem;
}

summary::-webkit-details-marker {
    display: none
}

.i36IEKMzp1KayBh6en3C {
    height: 0.75rem;
    width: 0.75rem;
    border-radius: 100%;
}

.i36IEKMzp1KayBh6en3C.tpf9pw89axajG9bAkzBt {
    background-color: var(--status-active-color);
}

.i36IEKMzp1KayBh6en3C.roqXFjm7z0jhvtCd7toZ {
    background-color: var(--status-inactive-color);
}

.i36IEKMzp1KayBh6en3C.S6u09tZWPuPDVKYlfKR4 {
    background-color: var(--status-deactivated-color);
}

.wI2O9qmKXjfqCyYUImhg {
    width: 1.25rem;
    height: auto;
    transform-origin: center center;
    will-change: transform;
    transition: transform var(--hover-transition-duration) ease-in-out;
}

.wI2O9qmKXjfqCyYUImhg :where(path, rect, polyline, circle) {
    stroke: currentColor !important;
}

details[open] .wI2O9qmKXjfqCyYUImhg {
    transform: rotate(90deg);
}

.WFw3PEeZlbXtkMx4SbuW {
    position: relative;
    contain: none;
}

.WFw3PEeZlbXtkMx4SbuW .JE9jCozBwPR5rUzDcETd {
    position: fixed;
    left: 0;
    right: 0;
    top: calc(100% - 0.5rem);
    z-index: 3;
    background: var(--ocean-gradient);
    border: 0.125rem solid #00C49A;
    border-radius: 0.5rem;
    padding: 0.5rem 0.75rem;
    box-shadow: var(--map-popup-box-shadow);
}

.AkyXdFbdG94paB3pkj4z {
    font-family: var(--map-body-font);
    font-size: var(--map-body-font-size);
    line-height: 1.2;
}

.WFw3PEeZlbXtkMx4SbuW .AkyXdFbdG94paB3pkj4z {
    --body-text-color: #fff;
}

.JE9jCozBwPR5rUzDcETd {
    margin-top: 0.25rem;
    cursor: default;
}

#gw-map .JE9jCozBwPR5rUzDcETd span.XDAOTze0S8pV8t9jcfiS.map-body,
#gw-map .JE9jCozBwPR5rUzDcETd p.map-body {
    color: #fff;
    font-size: var(--map-small-body-font-size);
}

.JE9jCozBwPR5rUzDcETd .XDAOTze0S8pV8t9jcfiS {
    display: block;
}

.yqmnuaACyWio_ZmP4ue_ {
    all: unset;
    color: var(--map-accent-color);
    cursor: pointer;
    margin-top: 0.5em;
    font-family: var(--map-body-font);
    font-size: var(--map-sub-body-font-size);
    font-weight: 700;
    display: block;
}

.Vwz69PzLSJ0egoa3F6wb {
    display: inline;
}

.Vwz69PzLSJ0egoa3F6wb button {
    line-height: 1;
    vertical-align: middle;
}

.Vwz69PzLSJ0egoa3F6wb svg {
    width: 1.25rem;
    height: 1.25rem;
}

.swgleGmfZO0ZeiB8SlIM {
    display: inline;
}`, "",{"version":3,"sources":["webpack://./../core/components/LastSeenInfo.module.css"],"names":[],"mappings":"AAAA;IACI,yCAAyC;IACzC,iCAAiC;IACjC,mCAAmC;AACvC;;AAEA;IACI,0BAA0B;IAC1B,iCAAiC;IACjC,WAAW;IACX,8BAA8B;IAC9B,sBAAsB;IACtB,uCAAuC;IACvC,0CAA0C;IAC1C,eAAe;IACf,WAAW;IACX,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,oCAAoC;IACpC,mBAAmB;IACnB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,8CAA8C;AAClD;;AAEA;IACI,iDAAiD;AACrD;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,+BAA+B;IAC/B,sBAAsB;IACtB,kEAAkE;AACtE;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,OAAO;IACP,QAAQ;IACR,wBAAwB;IACxB,UAAU;IACV,iCAAiC;IACjC,8BAA8B;IAC9B,qBAAqB;IACrB,uBAAuB;IACvB,uCAAuC;AAC3C;;AAEA;IACI,iCAAiC;IACjC,oCAAoC;IACpC,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;IACnB,eAAe;AACnB;;AAEA;;IAEI,WAAW;IACX,0CAA0C;AAC9C;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,8BAA8B;IAC9B,eAAe;IACf,iBAAiB;IACjB,iCAAiC;IACjC,wCAAwC;IACxC,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB","sourcesContent":["details {\r\n    --lastseen-border: 0.125rem solid #00C49A;\r\n    --lastseen-border-radius: 0.75rem;\r\n    --lastseen-padding: 0.25rem 0.75rem;\r\n}\r\n\r\ndetails {\r\n    --default-icon-color: #fff;\r\n    background: var(--ocean-gradient);\r\n    color: #fff;\r\n    border: var(--lastseen-border);\r\n    border-radius: 0.75rem;\r\n    padding: 0.25rem 0.75rem 0.25rem 0.5rem;\r\n    margin: 0.75rem -0.25rem 0.25rem -0.125rem;\r\n    cursor: pointer;\r\n    width: 100%;\r\n    box-sizing: border-box;\r\n    contain: content;\r\n}\r\n\r\ndetails>summary {\r\n    list-style: none;\r\n    display: grid;\r\n    grid-template-columns: auto 1fr auto;\r\n    align-items: center;\r\n    gap: 0.5rem;\r\n    min-height: 1.75rem;\r\n}\r\n\r\nsummary::-webkit-details-marker {\r\n    display: none\r\n}\r\n\r\n.statusBullet {\r\n    height: 0.75rem;\r\n    width: 0.75rem;\r\n    border-radius: 100%;\r\n}\r\n\r\n.statusBullet.statusActive {\r\n    background-color: var(--status-active-color);\r\n}\r\n\r\n.statusBullet.statusInactive {\r\n    background-color: var(--status-inactive-color);\r\n}\r\n\r\n.statusBullet.statusDeactivated {\r\n    background-color: var(--status-deactivated-color);\r\n}\r\n\r\n.summaryArrow {\r\n    width: 1.25rem;\r\n    height: auto;\r\n    transform-origin: center center;\r\n    will-change: transform;\r\n    transition: transform var(--hover-transition-duration) ease-in-out;\r\n}\r\n\r\n.summaryArrow :where(path, rect, polyline, circle) {\r\n    stroke: currentColor !important;\r\n}\r\n\r\ndetails[open] .summaryArrow {\r\n    transform: rotate(90deg);\r\n}\r\n\r\n.overlayDetails {\r\n    position: relative;\r\n    contain: none;\r\n}\r\n\r\n.overlayDetails .fullDateContainer {\r\n    position: fixed;\r\n    left: 0;\r\n    right: 0;\r\n    top: calc(100% - 0.5rem);\r\n    z-index: 3;\r\n    background: var(--ocean-gradient);\r\n    border: 0.125rem solid #00C49A;\r\n    border-radius: 0.5rem;\r\n    padding: 0.5rem 0.75rem;\r\n    box-shadow: var(--map-popup-box-shadow);\r\n}\r\n\r\n.dateSummaryText {\r\n    font-family: var(--map-body-font);\r\n    font-size: var(--map-body-font-size);\r\n    line-height: 1.2;\r\n}\r\n\r\n.overlayDetails .dateSummaryText {\r\n    --body-text-color: #fff;\r\n}\r\n\r\n.fullDateContainer {\r\n    margin-top: 0.25rem;\r\n    cursor: default;\r\n}\r\n\r\n:global(#gw-map) .fullDateContainer span.fullDateText:global(.map-body),\r\n:global(#gw-map) .fullDateContainer p:global(.map-body) {\r\n    color: #fff;\r\n    font-size: var(--map-small-body-font-size);\r\n}\r\n\r\n.fullDateContainer .fullDateText {\r\n    display: block;\r\n}\r\n\r\n.closeFullDate {\r\n    all: unset;\r\n    color: var(--map-accent-color);\r\n    cursor: pointer;\r\n    margin-top: 0.5em;\r\n    font-family: var(--map-body-font);\r\n    font-size: var(--map-sub-body-font-size);\r\n    font-weight: 700;\r\n    display: block;\r\n}\r\n\r\n.lastSeenTip {\r\n    display: inline;\r\n}\r\n\r\n.lastSeenTip button {\r\n    line-height: 1;\r\n    vertical-align: middle;\r\n}\r\n\r\n.lastSeenTip svg {\r\n    width: 1.25rem;\r\n    height: 1.25rem;\r\n}\r\n\r\n.tagStatusText {\r\n    display: inline;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"statusBullet": `i36IEKMzp1KayBh6en3C`,
	"statusActive": `tpf9pw89axajG9bAkzBt`,
	"statusInactive": `roqXFjm7z0jhvtCd7toZ`,
	"statusDeactivated": `S6u09tZWPuPDVKYlfKR4`,
	"summaryArrow": `wI2O9qmKXjfqCyYUImhg`,
	"overlayDetails": `WFw3PEeZlbXtkMx4SbuW`,
	"fullDateContainer": `JE9jCozBwPR5rUzDcETd`,
	"dateSummaryText": `AkyXdFbdG94paB3pkj4z`,
	"fullDateText": `XDAOTze0S8pV8t9jcfiS`,
	"closeFullDate": `yqmnuaACyWio_ZmP4ue_`,
	"lastSeenTip": `Vwz69PzLSJ0egoa3F6wb`,
	"tagStatusText": `swgleGmfZO0ZeiB8SlIM`
};
module.exports = ___CSS_LOADER_EXPORT___;
